import React from 'react';
import { Card } from 'react-bootstrap';
import hero from '../images/hero.jpg';
export default function Jumbotron() {
  return (
    <Card className='card-jumbo'>
      <Card.Img src={hero} alt='Card image' className='card-image-jumbo' />
      <Card.ImgOverlay
        className='card-jumbo-overlay'
        className='card-jumbo-title'
      >
        <Card.Text className='card-jumbo-title' className='card-jumbo-title'>
          Sneakers
        </Card.Text>

        <Card.Text className='card-jumbo-text'>
          On Sneaks, every sneaker you want is always available and authentic.
          Buy and sell new sneakers & shoes from Air Jordan, adidas, Nike, Yeezy
          and more!
        </Card.Text>
      </Card.ImgOverlay>
    </Card>
  );
}
